import { API_JWT_BASE_URL } from '../http'

export const SEARCH_SUPPORTING_APPLICATIONS_API = `${API_JWT_BASE_URL}/SupportingApplications/search`
export const IMPORT_SUPPORTING_APPLICATION_API = `${API_JWT_BASE_URL}/SupportingApplications/import`
export const GET_SUPPORTING_APPLICATION_API = `${API_JWT_BASE_URL}/SupportingApplications/`
export const OBSOLETE_SUPPORTING_APPLICATION_API = `${API_JWT_BASE_URL}/SupportingApplications/obsolete`

export const SUPPORTING_APPLICATIONS_QUERY_KEYS = {
  SEARCH_SUPPORTING_APPLICATIONS: 'SEARCH_SUPPORTING_APPLICATIONS',
  GET_SUPPORTING_APPLICATION: 'GET_SUPPORTING_APPLICATION',
  IMPORT_SUPPORTING_APPLICATION: 'IMPORT_SUPPORTING_APPLICATION',
  OBSOLETE_SUPPORTING_APPLICATION: 'OBSOLETE_SUPPORTING_APPLICATION'
}
